import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import FormItem from '@/components/ui/FormItem';
import { RPNScore } from './styles';

interface TaskRPNProps {
	fieldName: NamePath;
	task_rpn: number;
}

export function TaskRPN({ fieldName, task_rpn }: Readonly<TaskRPNProps>) : JSX.Element {
	return (
		<Col style={{ alignItems: 'center', width: '100%', height: '100%' }}>
			<FormItem
				name={fieldName}
				label={`${I18n.get('RPN')}:`}
				labelAlign="left"
				labelCol={{ flex: 'none', style: { padding: 0, marginRight: '0.5rem' } }}
				wrapperCol={{ flex: 'none' }}
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: 'fit-content',
					margin: '0 auto'
				}}
			>
				{task_rpn === 0 ? 'N/A' : <RPNScore>{String(task_rpn)}</RPNScore>}
			</FormItem>
		</Col>
	);
}
